import useAxios from './useAxios'
import { AuthenticatedUser } from '../types'

interface LoginResponse extends AuthenticatedUser {
  token: string
}

interface ValidateEmailResponse {
  ok: true
}

interface UserStoreRequest {
  first_name: string
  last_name: string
  phone_number: string
  email: string
  password: string
  recaptcha?: string
}

type UserStoreResponse = LoginResponse

interface PasswordEmailRequest {
  email: string
}

interface PasswordEmailResponse {
  message: string
}

interface PasswordResetRequest {
  user_id: string
  reset_code: string
  password: string
}

interface PasswordResetResponse {
  message: string
}

const useAuth = () => {
  const instance = useAxios()

  const validateEmail = async (email: string) =>
    await instance.post<ValidateEmailResponse>('ac/v1/users/check', { email })

  const register = async (request: UserStoreRequest) => await instance.post<UserStoreResponse>('ac/v1/users', request)

  const sendResetLinkEmail = async (request: PasswordEmailRequest) =>
    await instance.post<PasswordEmailResponse>('ac/v1/passwords/email', request)

  const resetPassword = async (request: PasswordResetRequest) =>
    await instance.post<PasswordResetResponse>('ac/v1/passwords/reset', request)

  const requestToken = async (email: string, password: string) =>
    await instance.post<LoginResponse>('jwt-auth/v1/token', { username: email, password })

  const profile = async () => await instance.get('ac/v1/users/me')
  const logout = async () => await instance.delete('ac/v1/auth/logout')

  return {
    requestToken,
    validateEmail,
    register,
    profile,
    logout,
    sendResetLinkEmail,
    resetPassword,
  }
}

export default useAuth
